import * as React from "react";
import Input from "../Input-new/Input";
import { formatNotesDateTime } from "../../utils";

const NotesInfo = ({ data, viewMode, deleted, handleChangeInput }) => {
    // const [notesValue, setNotesValue] = React.useState();
    const lastDateAndUpdateBy = `${formatNotesDateTime(data.arcimedes_modified)}\n${data.arcimedes_modified_by}`
    return (
      <div className="Notes-info">
        <div className="Notes-info_column Notes-info-box">
          <Input
            className="Notes-info_column_item"
            required
            valueType="text"
            inputType="textarea"
            //name="notes"
            name="notes"
            label="Notes"
            //value={data.NOTES}
            value={data.notes}
            viewMode={viewMode}
            handleParentChange={handleChangeInput}
            deleted={deleted}
          />
          {/* {(data.arcimedes_modified_by || data.arcimedes_modified) && (
            <div style={{ marginTop: "8px", fontSize: "12px", color: "#888" }}>
              Last updated: {lastDateAndUpdateBy}
            </div>
          )} */}
        </div>
      </div>
    );
};

export default NotesInfo;
